import { render, staticRenderFns } from "./datatime.vue?vue&type=template&id=44e067e2&scoped=true&"
import script from "./datatime.vue?vue&type=script&lang=js&"
export * from "./datatime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e067e2",
  null
  
)

export default component.exports